// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollToTop_wrapper__i6261","scrollTopButton":"ScrollToTop_scrollTopButton__CYpO_","image":"ScrollToTop_image__hPyUm"};